<template>
  <div
    :style="{
      height: '30px'
    }"
  >
    <label
      :style="{
        //font: 'normal normal normal 16px/19px Lato',
        fontSize: '16px/19px',
        color: '#333333',
        verticalAlign: 'middle'
      }"
      >{{ field.title }}
      <span v-if="field.required">*</span>
      <span v-if="!field.required" :style="{ color: '#707070' }"
        >- optional</span
      >
    </label>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "InputLabel",

  props: ["field"],

  mounted() {},
  computed: {},
  methods: {}
};
</script>
